import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-U1-P11-E1",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page11/Key/E1answerKey.jpg",
    component: T6v2,
    // checkDuplicated: true,
    inputSize: 130,
    // maxLength: 1,
    stylesTextInput: {
      fontSize: "26px",
      textAlign: "center",
      background: 'transparent',
    },
    titleQuestion: [
      {
        num: "1",
        title: `Complete the table using was or were
        and the correct -ing form of the verbs in brackets.`,
        color: "rgb(120,199,215)",
        star:1
      },
    ],
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
      <div style='position: relative;'>
        <div style='display:flex'>
            <img src="/img/FriendsPlus/Page11/E1/1.jpg" style='height:26cm;'  >
        </div>
        <div style=" position: absolute; top: 136px; left: 810px; "><input id='0' style="width:0px"></input></div>
        <div style=" position: absolute; top: 255px; left: 545px; "><input id='1' style="width:0px"></input></div>
        <div style=" position: absolute; top: 255px; left: 810px; "><input id='2' style="width:0px"></input></div>
        <div style=" position: absolute; top: 453px; left: 549px; "><input id='3' style="width:0px"></input></div>
        <div style=" position: absolute; top: 517px; left: 549px; "><input id='4' style="width:0px"></input></div>
        <div style=" position: absolute; top: 517px; left: 815px; "><input id='5' style="width:0px"></input></div>
        <div style=" position: absolute; top: 707px; left: 65px; "><input id='6' style="width:0px"></input></div>
        <div style=" position: absolute; top: 759px; left: 705px; "><input id='7' style="width:0px"></input></div>
        <div style=" position: absolute; top: 831px; left: 65px; "><input id='8' style="width:0px"></input></div>
        <div style=" position: absolute; top: 832px; left: 747px; "><input id='9' style="width:0px"></input></div>
        
        
        
        
    
      </div>
        `,
        answer: ["listening", "were", "watching", "was", "were", "doing", "Was", "was", "Were", "were"],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-U1-P11-E2",
    audio: "",
    video: "",
    exerciseKey: "/img/FriendsPlus/Page11/Key/E2answerKey.jpg",
    component: T6v2,
    // checkDuplicated: true,
    inputSize: 530,
    maxLength: 1,
    stylesTextInput: {
      fontSize: "24px",
      textAlign: "left",
      background: 'transparent',
    },
    titleQuestion: [
      {
        num: "2",
        title: `Write sentences and questions using the 
        past continuous.`,
        color: "rgb(120,199,215)",
        star:2
      },
    ],
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
      <div>
          <div>Rashid / wait for / his bus for twenty minutes</div>
          <div><strong>Rashid was waiting for his bus for twenty minutes.</strong></div>
          <div><strong style="margin-right:15px">1</strong>what / you / study / in class / ?</div>
          <div>#</div>
          <div>#</div>
          <div><strong style="margin-right:15px">2</strong>they / not listen / to the song</div>
          <div>#</div>
          <div>#</div>
          <div><strong style="margin-right:15px">3</strong>he / eat / a sandwich ? No / he / not</div>
          <div>#</div>
          <div>#</div>
          <div><strong style="margin-right:15px">4</strong>we / play / computer games / all evening</div>
          <div>#</div>
          <div>#</div>
          <div><strong style="margin-right:15px">5</strong>you / work ? Yes / I</div>
          <div>#</div>
          <div>#</div>
          <div><strong style="margin-right:15px">6</strong>who / wear / a hoodie / ?</div>
          <div>#</div>
          <div>#</div>
      </div>
        `,
        answer: ["What were you studying in class?","",
          "They weren't listening to the song.","",
          "Was he eating a sandwich?", "No, he wasn't.", 
          "We were playing computer games all evening.","",
          "Were you working?", "Yes, I was.", 
          "Who was wearing a hoodie?","" ],
      },
    ],
  },
  3: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P11-E3",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page11/Key/E3answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 180,
    stylesTextInput: {
      fontSize: "24px",
      textAlign: "center	",
      background: 'transparent',
    },
    titleQuestion: [
      {
        num: "3",
        title: `
					
        Complete the description using the past 
        simple or past continuous form of the verbs in 
				`,
        color: "rgb(120,199,215)",
        star:2
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div style='position: relative;'>
        <div style='display:flex'>
            <img src="/img/FriendsPlus/Page11/E3/1.jpg" style='height:26cm;'  >
        </div>
        <div style=" position: absolute; top: 95px; left: 250px; "><input id='0' style="width:0px"></input></div>
        <div style=" position: absolute; top: 139px; left: 125px; "><input id='1' style="width:0px"></input></div>
        <div style=" position: absolute; top: 183px; left: 530px; "><input id='2' style="width:0px"></input></div>
        <div style=" position: absolute; top: 272px; left: 429px; "><input id='3' style="width:0px"></input></div>
        <div style=" position: absolute; top: 315px; left: 229px; "><input id='4' style="width:0px"></input></div>
        <div style=" position: absolute; top: 359px; left: 115px; "><input id='5' style="width:0px"></input></div>
        <div style=" position: absolute; top: 402px; left: 245px; "><input id='6' style="width:0px"></input></div>
        <div style=" position: absolute; top: 448px; left: 110px; "><input id='7' style="width:0px"></input></div>
       
        
        
        
        
    
      </div>
        `,
        answer: [
          "took", "was cooking", "was", "were chatting", 
"was going", "was getting", "was", "ate" ,
        ],
      },
    ],
  },
  4: {
    unit: "Unit 1",
    id: "FP8-WB-demo-2023-U1-P11-E4",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    hideBtnFooter:true,
    inputSize: 180,
    titleQuestion: [
      {
        num: "4",
        title: `
        Answer the questions. Write complete 
        sentences that are true for you.
				`,
        color: "rgb(120,199,215)",
        star:3
      },
    ],
    questionImage: [],
    textareaStyle: { width: 900 },
    hideBtnFooter: true,
    isHiddenCheck: true,
    questions: [
      {
        title: `
        <div>
        
        <div><strong style="margin-right:20px">1</strong>Think of a photo you like. Who took it? What 
        was happening? What were the people 
        wearing?</div>
        <div><b>When I was younger, I used to listen to music on an iPod.
        Now I use my smartphone or tablet.</b></div>
        <textarea id="0" rows="4"></textarea>
        <div><strong style="margin-right:20px">2</strong>What was your family doing when you arrived 
        home yesterday? What happened next?</div>
        <textarea id="1" rows="4"></textarea>
        <div><strong style="margin-right:20px">3</strong>What were you wearing the last time you went 
        out with friends? Where were you going? </div>
        <textarea id="1" rows="4"></textarea>

      </div>
        `,
        answer: [
          "",
        ],
      },
    ],
  },
};

export default json;
